export default __webpack_public_path__ + "static/media/card2.cf5f91a6.svg";